export enum SpecialistDecision {
  APPROVED = 'APPROVED',
  APPROVED_WITH_CONDITIONS = 'APPROVED_WITH_CONDITIONS',
  REJECTED = 'REJECTED',
  REWORK_REQUIRED = 'REWORK_REQUIRED'
}
